import { combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import loader from './reducer/loader';
import auth from './reducer/auth';
import user from './reducer/userData';

const reducers = combineReducers({
  loader,
  auth,
  user,
});

export default createStore(reducers, composeWithDevTools());
